import { useSelector } from "react-redux";
import { RootState } from "src/redux/redux-store";


interface ProfileMenuProps {
  onProfileClick: () => void;
  onLogoutClick: () => void;
  onSwitchSeatsClick: () => void;
}

const ProfileMenu = ({ onProfileClick, onLogoutClick, onSwitchSeatsClick }: ProfileMenuProps) => {
  const userState = useSelector((state: RootState) => state.userState);
  const isClientAdmin = userState.permissions?.groups?.includes('client_admin');
  const isClientUser = userState.permissions?.groups?.includes('client_user') || isClientAdmin;
  const isClient = isClientAdmin || isClientUser;

  const profileMenuItems = [
    {
      label: 'Account',
      onClick: onProfileClick,
      hidden: isClient,
    },
    {
      label: 'Switch Seats',
      onClick: onSwitchSeatsClick,
      hidden: !isClient,
    },
    {
      label: 'Log out',
      onClick: onLogoutClick,
    },
  ];


  return (
    <div className="absolute right-0 top-5 w-40 rounded-md bg-white shadow-lg z-50">
      <div className="py-1">
        {profileMenuItems.filter(item => !item.hidden).map(item => (
          <button
            key={item.label}
            onClick={item.onClick}
            className="block w-full px-4 py-2 text-left text-sm text-gray-701 hover:bg-gray-101"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileMenu;
